import {useTranslation} from '@aboutyou/i18n';
import {
  useTrackFeature,
  useTrackFeatureInViewImpression,
  useTrackOriginClick,
} from '@aboutyou/tracking';
import {
  Button,
  COLORS,
  GenericIconName,
  Icon,
  Text,
} from '@aboutyou/ui-components';
import {styled as linariaStyled} from '@linaria/react';
import React from 'react';
import sc from 'styled-components';
import {useAuthenticationPrompt} from '../../../../features/Authentication/AuthenticationProvider/AuthenticationProvider';

export const LogInHintRow: React.FC = () => {
  const {t} = useTranslation();
  const trackFeature = useTrackFeature();
  const trackOriginClick = useTrackOriginClick();
  const {ref} = useTrackFeatureInViewImpression({label: 'loginHint_basket'});
  const {showUserAuthenticationPrompt} = useAuthenticationPrompt();
  const onLogInButtonClick = () => {
    trackOriginClick('loginHint_basket')();
    trackFeature({eventType: 'click', label: 'loginHint_basket'});
    showUserAuthenticationPrompt({
      needsCheckoutSession: true,
    });
  };
  return (
    <>
      <StyledLogInHintWrapper
        data-testid="logInHintRow"
        ref={ref as React.RefObject<HTMLDivElement | null>}
      >
        <StyledText size="px12" textAlignment="center" weight="mediumHeavy">
          {t('Log in to see if personal discounts are available for you')}
        </StyledText>
        <StyledButton
          data-testid="logInHintButton"
          onClick={onLogInButtonClick}
          disableShadow
          type="secondary"
          aria-label={undefined}
        >
          <StyledLogInIcon size="XS" asset={GenericIconName.User} />
          {t('Log in')}
        </StyledButton>
      </StyledLogInHintWrapper>
    </>
  );
};

const StyledLogInIcon = linariaStyled(Icon)`
  margin-right: 4px;
`;

const StyledLogInHintWrapper = sc.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

const StyledButton = sc(Button)`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  width: 100%;
  border: 1px solid ${COLORS.Black};
  font-size: 12px;
`;

const StyledText = sc(Text)`
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-bottom: 12px;
`;
